type Mapper<T, U> = (item: T) => U[];
const DEFAULT_MAPPER = (item: any) => item && Array.isArray(item) ? item : [];

type Equal<T> = (item1: T, item2: T) => boolean;
const DEFAULT_EQUAL = (item1: any, item2: any) =>
  (
    item1 && item2 && (
      (item1.id && item2.id && item1.id === item2.id)
      ||
      (item1.code && item2.code && item1.code === item2.code)
    )
  ) || item1 === item2;

interface Array<T> {
  flatMap(this: T[][]): T[];
  flatMap<U>(this: T[], mapper?: Mapper<T, U>): U[];
  unique(this: T[], equal?: Equal<T>): T[];
  same(this: T[], other: T[], equal?: Equal<T>): boolean;
}

if (!Array.prototype.flatMap) {
  Array.prototype.flatMap = function flatMap<T, U>(mapper: Mapper<T, U> = DEFAULT_MAPPER): U[] {
    return this.reduce(
      (cumulus: U[], item: T) => {
        return [ ...cumulus, ...mapper(item) ];
      },
      []
    );
  };
}

if (!Array.prototype.unique) {
  Array.prototype.unique = function unique<T>(equal: Equal<T> = DEFAULT_EQUAL): T[] {
    return this.filter((item, i, origArray) => {
      return origArray.findIndex(other => equal(item, other)) === i;
    });
  };
}

if (!Array.prototype.same) {
  Array.prototype.same = function same<T>(this: T[], other: T[], equal: Equal<T> = DEFAULT_EQUAL) {
    if (this === other) {
      return true;
    }

    if (!other || (this.length !== other.length)) {
      return false;
    }

    return this.length === 0 ||
      this.every(el => other.some(otherEl => equal(el, otherEl))) ||
      other.every(otherEl => this.some(el => equal(otherEl, el)));
  };
}



// WEBPACK FOOTER //
// ./src/gs-core/common/util/array.prototype.ts